(function (m, ei, q, i, a, j, s) {
  m[i] = m[i] || function () {
    (m[i].a = m[i].a || []).push(arguments)
  }
  j = ei.createElement(q)
  s = ei.getElementsByTagName(q)[0]
  j.async = true
  j.charset = 'UTF-8'
  j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t'
  s.parentNode.insertBefore(j, s)
})(window, document, 'script', '_MEIQIA')

let MeiQiaConfig = {
  // 客服组token
  groupToken: '407125bb2d8bf1da1a7484170f901988'
  // 是否展示按钮
  // showButton: true,
  // 获取未读信息，可页面自定义展示
  // unReadFn: function yourFunction(msg) {
  //   console.log(msg)
  // }
}

// 企业id：162883 -- 查询处：https://app.meiqia.com/setting/web-widget
_MEIQIA('entId', 162883) // eslint-disable-line

// 阻止自动初始化
_MEIQIA('manualInit') // eslint-disable-line

if (MeiQiaConfig) {
  // 展示按钮
  if (!MeiQiaConfig.showButton) {
    _MEIQIA('withoutBtn') // eslint-disable-line
  }
  // 隐藏弹框
  if (!MeiQiaConfig.showPanel) {
    _MEIQIA('hidePanel') // eslint-disable-line
  }
  // 查看未读
  if (MeiQiaConfig.unReadFn) {
    _MEIQIA('getUnreadMsg', MeiQiaConfig.unReadFn) // eslint-disable-line
  }
  // 指定分配客服或客服组
  if (MeiQiaConfig.hasOwnProperty('agentToken')) {
    _MEIQIA('assign', { // eslint-disable-line
      // 客服token
      agentToken: MeiQiaConfig.agentToken
    })
  } else if (MeiQiaConfig.hasOwnProperty('groupToken')) {
    _MEIQIA('assign', { // eslint-disable-line
      // 客服组token，如果已有客服token，客服组token将被忽略
      groupToken: MeiQiaConfig.groupToken
    })
  }
  // 初始化
  _MEIQIA('init') // eslint-disable-line
}
// 展开美洽弹框
export const clickShowMeiQia = () => {
  _MEIQIA('showPanel') // eslint-disable-line
}
// 传递客户信息
export const transformInfo = (obj) => {
  _MEIQIA('metadata', obj) // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/utils/meiqia.js